import type { Chatbot, Message } from '@types'
import axios from 'axios'

import env from '../environments'

export async function getChatbot(id: string, accessToken: string) {
	const response = await axios.get(`${env.chatbotApiUrl}/chats/${id}`, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: `Bearer ${accessToken}`
		}
	})

	return response.data.chatbot as Chatbot
}

export async function getMessages(id: string, accessToken: string) {
	const response = await axios.get(`${env.chatbotApiUrl}/chats/${id}/messages`, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: `Bearer ${accessToken}`
		}
	})

	return response.data.messages as Message[]
}

export async function getMessage(
	chatId: string,
	id: string,
	accessToken: string
) {
	const response = await axios.get(`${env.chatbotApiUrl}/chats/${chatId}/messages/${id}`, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: `Bearer ${accessToken}`
		}
	})

	return response.data.message as Message
}

export async function sendMessage(
	chatId: string,
	query: string,
	accessToken: string,
	isFollowUp?: boolean | undefined
) {
	const urlParams = new URLSearchParams({
		query,
		isFollowUp: isFollowUp?.toString() ?? 'false'
	})
	const response = await axios.get(`${env.chatbotApiUrl}/chats/${chatId}/query?${urlParams.toString()}`, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: `Bearer ${accessToken}`
		}
	})

	return response.data as {userMessage: Message; assistantMessage: Message}
}
